import React from 'react';

const VideoIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 14"><path d="M12.64.5H2.54A2.43 2.43 0 0 0 .13 2.92v8.16a2.43 2.43 0 0 0 2.43 2.42h10.1a2.43 2.43 0 0 0 2.41-2.42V2.92A2.41 2.41 0 0 0 12.64.5ZM20.46 1.83c-.14.03-.29.1-.41.17l-3.78 2.18V9.8l3.8 2.17c.7.42 1.58.17 1.99-.53.12-.22.2-.46.2-.72V3.24c0-.9-.86-1.63-1.8-1.4Z" /></svg>
);

export default VideoIcon;